<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template #custom_actions>
        <menu-search v-if="menuAdvanceModeEnabled" v-model="searchQuery" />
      </template>
    </page-header>

    <menu-options
      :menu-title="menuTitle"
      :search="searchQuery"
      :can-navigate="validateStudent"
      :advance-mode="menuAdvanceModeEnabled"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import { MenuOptions, MenuSearch } from '@/components/common/menu';
import menuNavigation from '@/mixin/menuNavigation.mixin';
import navMenuTitles from '@/utils/constants/navMenuTitles';

export default {
  name: 'HumanResourcesMenu',
  mixins: [menuNavigation],
  components: {
    PageHeader,
    MenuOptions,
    MenuSearch,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-book-open',
        title: 'Recursos Humanos',
        routes: ['Inicio', 'Recursos Humanos'],
      },
      menuTitle: navMenuTitles.HumanResources,
      searchQuery: '',
    };
  },
  computed: {
    menuNavigationOptions() {
      return {
        trackViewCard: true,
      };
    },
  },
};
</script>
